import { useEffect, useState } from 'preact/hooks'
import { getWidgetLayout, subscribeWidgetLayout } from './widget_manager.js'

export function useWidgetLayout() {
  const [layout, setLayout] = useState(getWidgetLayout())
  useEffect(() => subscribeWidgetLayout(setLayout), [])
  return layout
}
